<div class="dialog-container">
  <div class="dialog-header">
    <h2>Confirmar Submissão</h2>
    <button mat-icon-button [mat-dialog-close]="null" class="close-button" matTooltip="Fechar diálogo">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content mb-2">
    <app-mat-spinner-overlay [overlay]="true" *ngIf="loading"></app-mat-spinner-overlay>

    <div class="confirmacao-texto">
      <mat-icon class="confirmacao-icon">warning</mat-icon>
      <p>
        Você está prestes a submeter <strong>{{ data.totalSocios }} sócio(s)</strong>
        para validação junto à SWAP/Bacen.
      </p>
      <p>
        Após a submissão, não será possível editar os dados até que o retorno seja processado.
        Deseja continuar?
      </p>
    </div>

    <div class="row g-2 mt-3">
      <div class="col d-flex justify-content-end gap-2">
        <button mat-flat-button class="btn-confirmar" (click)="onConfirmar()" [disabled]="loading">
          <mat-icon>send</mat-icon> Submeter
        </button>
        <button mat-flat-button (click)="onCancelar()" [disabled]="loading">
          <mat-icon>close</mat-icon> Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
